import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from "@mui/material";
import { Check, Close, Delete } from "@mui/icons-material";
import PermissionWrapper from "../../PermissionWrapper";

export default function InlineEditActions({
  onSave,
  onDelete,
  onCancel,
  loading,
  canAdd,
  canPatch,
  canRemove,
  activeWindow,
  title
}) {
  return (
    <>
      <Tooltip title={`Submit/Update ${title}`}>
        <IconButton
          onClick={onSave}
          className="text-green-600"
          disabled={loading || (!activeWindow && !canAdd) || (activeWindow && !canPatch)}
        >
          <Check />
        </IconButton>
      </Tooltip>
      <PermissionWrapper
        permission={canRemove && activeWindow}
      >
        <Tooltip title={`Delete ${title}`}>
          <IconButton
            onClick={onDelete}
            className="text-red-600"
          >
            <Delete />
          </IconButton>
        </Tooltip>
      </PermissionWrapper>
      <Tooltip title="Cancel">
        <IconButton onClick={onCancel}>
          <Close />
        </IconButton>
      </Tooltip>
    </>
  );
}

InlineEditActions.propTypes = {
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  canAdd: PropTypes.bool.isRequired,
  canPatch: PropTypes.bool.isRequired,
  canRemove: PropTypes.bool.isRequired,
  activeWindow: PropTypes.object,
  title: PropTypes.string.isRequired
};

InlineEditActions.defaultProps = {
  activeWindow: null
}; 